const DevEndpoints = {
    ATOZ: 'https://atoz.integ.amazon.com',
    ATOZ_API_GATEWAY: 'https://atoz-api.integ.amazon.com',
    ATOZ_SHOUTOUTS_ASSETS: 'https://atoz-kudos-app.integ.amazon.work',
    HUB: 'https://essportal.integ.amazon.com',
};
export default DevEndpoints;
//# sourceMappingURL=endpoints.dev.js.map